import { TransparentPricingDS } from '@src/components/blocks/transparent-pricing-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import TransparentPricingLegacy from './transparent-pricing-legacy'
import { TransparentPricingProps } from './transparent-pricing.types'

const TransparentPricing = (props: TransparentPricingProps) => {
  if (shouldUseDesignSystem()) {
    return <TransparentPricingDS {...props} />
  }
  return <TransparentPricingLegacy {...props} />
}

export type { TransparentItemProps, TransparentPricingProps } from './transparent-pricing.types'

export default TransparentPricing
